import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChildren,
} from '@angular/core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { MenuChild, MenuItem } from 'src/app/core/services/shared';

@Component({
  selector: 'app-sidenav-menu-item',
  templateUrl: './sidenav-menu-item.component.html',
  styleUrls: ['./sidenav-menu-item.component.scss'],
})
export class SidenavMenuItemComponent {
  @ViewChildren(SidenavMenuItemComponent) children?: SidenavMenuItemComponent[];

  @Input() item!: MenuItem | MenuChild;
  @Input() isMenuActivated!: boolean;

  @Output() clicked = new EventEmitter();
  @Output() subMenuClicked = new EventEmitter();
  @Output() opened = new EventEmitter<MenuChild>();

  activatedChild: MenuChild | null = null;

  faChevronDown = faChevronDown;

  getItemStyle(): { [key: string]: string } {
    const length = this.getChildrenAmount();

    if (this.isMenuActivated) {
      return { 'max-height': `${length * 46}px` };
    }

    return {};
  }

  toggleActivatedChild(child: MenuChild): void {
    child.onClick?.();

    if (this.activatedChild === child) {
      this.clearActivatedChild();
      return;
    }

    this.opened.emit(child);
    this.activatedChild = child;
  }

  clearActivatedChild(): void {
    this.activatedChild = null;
    this.children?.forEach((child) => child.clearActivatedChild());
  }

  private getChildrenAmount(): number {
    const childrenAmount = this.item.children?.length ?? 0;
    const activatedChildChildrenAmount =
      this.activatedChild?.children?.length ?? 0;
    let length = childrenAmount + activatedChildChildrenAmount;

    if (this.children) {
      length += this.children.reduce(
        (acc, child) => acc + child.getChildrenAmount(),
        0
      );
    }

    return length;
  }
}
